import { Namespace, TFunction } from 'react-i18next';

import { formatDate } from '@app/services/date';

/** Человекочитаемый срок: «бессрочно» / «до …» / «с …» / «с … до …». */
export const formatTerm = (
  validFrom: string | null,
  validTo: string | null,
  t: TFunction<Namespace<'assignments'>>
): string => {
  const from = validFrom ? formatDate(validFrom) : '';
  const to = validTo ? formatDate(validTo) : '';
  if (from && to) {
    return t('term.fromUntil', { from, to });
  }
  if (to) {
    return t('term.until', { date: to });
  }
  if (from) {
    return t('term.from', { date: from });
  }
  return t('term.indefinite');
};
